import { createFileRoute, useRouteContext } from '@tanstack/react-router';
import { Button, Empty, Flex, Result } from 'antd';
import { useEffect } from 'react';

import { useListDatabaseSearchTabs } from '../../../../api';
import { usePermissions } from '../../../../modules/account/hooks';
import { useAiAssistant } from '../../../../modules/ai-next/providers';
import { Loader } from '../../../../ui/components/loader';

const DatabaseIndexRoute = () => {
  const { selectedOrganization } = useRouteContext({ from: '/_authenticated/_app' });
  const { can } = usePermissions();
  const canSearch = can('database', 'search');
  const navigate = Route.useNavigate();
  const { panel, uiContext } = useAiAssistant();

  const { data, isPending, isError } = useListDatabaseSearchTabs(selectedOrganization.id, {
    query: { enabled: canSearch },
  });
  const firstOpenTab = data?.data.open[0];

  useEffect(() => {
    if (firstOpenTab) {
      navigate({ to: '/database/$searchId', params: { searchId: firstOpenTab.id }, replace: true });
    }
  }, [firstOpenTab, navigate]);

  if (!canSearch) {
    return <Result status="403" title="You do not have permission to search the database" />;
  }

  if (isError) {
    return <Result status="error" title="Failed to load searches" />;
  }

  if (isPending || firstOpenTab) {
    return <Loader />;
  }

  return (
    <Flex flex={1} align="center" justify="center">
      <Empty description="Ask the assistant to find people in the database">
        <Button
          type="primary"
          onClick={() => {
            uiContext.setScopedFlow({ databaseSearchBuilder: {} });
            panel.newChat();
          }}
        >
          Create search with AI
        </Button>
      </Empty>
    </Flex>
  );
};

export const Route = createFileRoute('/_authenticated/_app/database/')({
  component: DatabaseIndexRoute,
});
